import { Props as MultiSelectProps } from '../MultiSelect/types'

export interface MultiselectWithDraggableItemsProps<T> extends MultiSelectProps<T> {
	onUpdateValueArray: (value: LabelValue<number>[]) => void
}

export const ITEM_TYPE = 'tag'

export type PotentialDropTarget = {
	dropTarget: string
	isAfter: boolean
	isBefore: boolean
}

export type ItemRefType = Record<Key, React.RefObject<HTMLSpanElement>>
